// removed by extract-text-webpack-plugin
module.exports = {"no-name":"name-cell-formatter__no-name___1QD0F"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/grid/cell-formatters/name-cell-formatter.scss
// module id = 1336
// module chunks = 0